<template>
  <v-app>
      <!-- Wrap everything in a single root element -->
      <v-main>
        <AppBar />
        <HeaderSection />
        <MarvelGrid />
        <Citation />
        <Footers />
      </v-main>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar.vue"; // Assuming you have an AppBar component
import HeaderSection from "./components/Header.vue"; // Assuming you have a Header component
import MarvelGrid from "./components/MarvelGrid.vue"; // Assuming you have a MarvelGrid component
import Citation from "./components/Citation.vue"; // Assuming you have a Citation component
import Footers from "./components/Footer.vue"; // Assuming you have a Footer component
export default {
  name: "App",
  components: {
    AppBar,
    HeaderSection,
    MarvelGrid,
    Citation,
    Footers,
  },
};
</script>

<style>
/* Add any global styles here */
body{
  font-family: 'Noto Sans', sans-serif;
}


</style>
